import $ from "jquery";
import GLightbox from "glightbox";

const lightboxVideo = () => {
    const el = {
        main: ".glightbox",
    };

    if ($(el.main).length === 0) return;

    const init = () => {
        initLightbox();
    };

    const initLightbox = () => {
        GLightbox({
            selector: el.main,
            touchNavigation: true,
        });
    };

    init();
};

try {
    lightboxVideo();
} catch (error) {
    console.error("lightboxVideo", error);
}